export var removeSuccess = function removeSuccess(t) {
  return {
    severity: 'success',
    message: t('Your account has been disconnected'),
    duration: 'medium'
  };
};
export var removeFailure = function removeFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to disconnect your account'),
    duration: 'medium'
  };
};
export var setVisibilitySuccess = function setVisibilitySuccess(t) {
  return {
    severity: 'success',
    message: t('Your visibility settings have been updated'),
    duration: 'medium'
  };
};
export var setVisibilityFailure = function setVisibilityFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to update your visibility settings'),
    duration: 'medium'
  };
};